<template>
	<div :class="[style.inputLabelContainer]" :style="'max-width:' + maxWidth ">
		<input 
			v-mask="mask" 
			v-bind:value="value" 
			:id="id"
			:autocomplete="autocomplete"
			:class="classNames"  
			:disabled="disabled == 'disabled'"
			:name="name"
			:placeholder="placeholder"
			:type="isPassword ? 'password' : 'text'"
			@input="$emit('input', $event.target.value)"
			@keyup="$emit('keyup', $event)"
			@keyup.up="$emit('keyup-up', $event)"
			@keyup.down="$emit('keyup-down', $event)"
			@keyup.enter="$emit('keyup-enter', $event)"
            @blur="$emit('blur', $event.target.value)"
			@focus="$emit('focus', $event)"
			@click="$emit('click', $event.target.value)" />
		<span errortext v-if="error" :class="[style.inputLabelError]" v-html="error"></span>
	</div>
	
</template>

<script>
	import style from './style.module.scss'

	import { textInputProps } from './text-input-mixin'

	import Vue from 'vue';

	import VueMask from 'v-mask'
	Vue.use(VueMask);

	export default {
		name: 'text-input',
		props: {
			maxWidth: {
				type: String,
				default: '',
				required: false
			},
			mask: {
				type: String,
				default: 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX',
				required: false
			},
			customInputStyles: {
				type: Array,
				default() {
					return [];
				}
			},
			disabled: {
				type: String,
				default: ''
			}
		},
		mixins: [textInputProps],
		data() {
			return {
				style: style
			}
		},
		computed: {
			classNames() {
				const classNames = [this.style.input]
				if(this.size == 'mid') classNames.push(this.style.inputMid)
				else if(this.size == 'lg') classNames.push(this.style.inputLg)

				if(this.error) classNames.push(this.style.inputError)

				if(this.customInputStyles && this.customInputStyles.length > 0){
					this.customInputStyles.forEach((item) => {
						classNames.push(item);
					});
				}

				return [classNames]
			}
		}
	}
</script>